var _line, _circle, _path, _line2, _circle2, _line3, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtraTimeStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 315.56,
    y1: 90,
    x2: 484.44,
    y2: 90,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 456.39,
    r: 253.61,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33,
    d: "M499.5,356.6c54.19,55.8,52.88,144.95-2.91,199.14-54.59,53.01-141.41,53.08-196.08.15"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 202.78,
    x2: 400,
    y2: 90,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 456.39,
    r: 28.05,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 287.22,
    x2: 400,
    y2: 428.05,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 174.44,
    y1: 202.78,
    x2: 230.83,
    y2: 259.17,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 625.56,
    y1: 202.78,
    x2: 569.17,
    y2: 259.17,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 56.39,
    strokeMiterlimit: 333.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraTimeStart);
export default __webpack_public_path__ + "static/media/extra-time-start.ebbb4991.svg";
export { ForwardRef as ReactComponent };